import { useState, useEffect } from 'react';
import axios from 'axios';
import logo from './logo.svg';
import './App.css';
import './style.css';
import SignUp from "./components/sign-up";
import Login from "./components/login";
import Main from "./components/main";
import AdminDashboard from "./components/AdminDashboard";
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Link, Navigate, useNavigate } from "react-router-dom";

function App() {
  const [user, setUser] = useState(null);
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    const verifySession = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/me`, {
          withCredentials: true
        });
        if (response.status === 200 && response.data.user) {
          setUser(response.data.user);
          setIsLogin(true);
        }
      } catch (error) {
        console.log("Session Check Failed:", error);
        setUser(null);
        setIsLogin(false);
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(`${SERVER_URL}/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error("Logout error", error);
    }
    setUser(null);
    setIsLogin(false);
  };

  if (loading) {
    return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar expand="lg" className="navbar-modern" fixed="top">
          <Container fluid>
            <Navbar.Brand as={Link} to={user?.is_admin ? "/admin" : "/"}>WowTalent</Navbar.Brand>

            <div className="d-flex align-items-center ms-auto d-lg-none me-2">
              {isLogin && user && (
                <div
                  className="rounded-circle d-flex justify-content-center align-items-center shadow-sm fw-bold fs-5"
                  style={{
                    width: "40px",
                    height: "40px",
                    background: "linear-gradient(to right, #003263, rgb(113 113 113))",
                    color: "#fdfdfdff",
                    border: "2px solid #f9fafbff"
                  }}
                  title={`Welcome, ${user.name}`}
                >
                  {user.name.charAt(0).toUpperCase()}
                </div>
              )}
            </div>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto align-items-center mt-3 mt-lg-0">
                {isLogin && user ? (
                  <div className="d-flex flex-column flex-lg-row align-items-center gap-3 gap-lg-4 w-100">
                    <div
                      className="d-none d-lg-flex rounded-circle justify-content-center align-items-center shadow-sm fw-bold fs-5"
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "linear-gradient(to right, #003263, rgb(113 113 113))",
                        color: "#fdfdfdff",
                        border: "2px solid #f9fafbff",
                        minWidth: "40px"
                      }}
                      title={`Welcome, ${user.name}`}
                    >
                      {user.name.charAt(0).toUpperCase()}
                    </div>
                    <Button variant="light border-2" onClick={handleLogout} className="btn-sm fw-bold px-4 w-auto mb-2 mb-lg-0">
                      Logout
                    </Button>
                  </div>
                ) : (
                  <>
                    <Nav.Link as={Link} to="/sign-up" className="nav-link-custom">Sign up</Nav.Link>
                    <Nav.Link as={Link} to="/login" className="nav-link-custom">Sign in</Nav.Link>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Routes>
          <Route path="/sign-up" element={<SignUp />} />
          <Route
            path="/login"
            element={
              !isLogin ? (
                <Login setUser={setUser} setIsLogin={setIsLogin} />
              ) : user?.is_admin ? (
                <Navigate to="/admin" />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/"
            element={
              isLogin
                ? (user?.is_admin ? <Navigate to="/admin" replace /> : <Main user={user} />)
                : <Navigate to="/login" replace />
            }
          />
          <Route
            path="/admin"
            element={isLogin && user?.is_admin ? <AdminDashboard user={user} /> : <Navigate to="/" replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
